var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 50.625C23.25 50.625 16.6875 47.25 12.75 41.25H22.5V37.5H7.5V52.5H11.25V45.5625C15.9375 51.1875 22.6875 54.375 30 54.375V50.625ZM58.125 43.125V39.375H54.1875C54 38.25 53.4375 37.125 52.875 36L55.6875 33.1875L53.0625 30.5625L50.25 33.375C49.3125 32.8125 48.1875 32.25 46.875 32.0625V28.125H43.125V32.0625C42 32.25 40.875 32.8125 39.75 33.375L36.9375 30.5625L34.3125 33.1875L37.125 36C36.5625 36.9375 36 38.0625 35.8125 39.375H31.875V43.125H35.8125C36 44.25 36.5625 45.375 37.125 46.5L34.3125 49.3125L36.9375 51.9375L39.75 49.125C40.6875 49.6875 41.8125 50.25 43.125 50.4375V54.375H46.875V50.4375C48 50.25 49.125 49.6875 50.25 49.125L53.0625 51.9375L55.6875 49.3125L52.875 46.5C53.4375 45.5625 54 44.4375 54.1875 43.125H58.125ZM45 46.875C41.8125 46.875 39.375 44.4375 39.375 41.25C39.375 38.0625 41.8125 35.625 45 35.625C48.1875 35.625 50.625 38.0625 50.625 41.25C50.625 44.4375 48.1875 46.875 45 46.875ZM37.5 18.75H47.25C41.0625 9.1875 28.3125 6.5625 18.75 12.75C12.9375 16.5 9.375 23.0625 9.375 30H5.625C5.625 16.5 16.5 5.625 30 5.625C37.3125 5.625 44.0625 8.8125 48.75 14.4375V7.5H52.5V22.5H37.5V18.75Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.bcdead1c82a458138f443b3fa8c3c91a.svg";
export { ForwardRef as ReactComponent };